import { objectOf } from "@altostra/type-validations";
import { number } from "@altostra/type-validations/lib/primitives";

import type {
  GetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult,
  PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult,
} from "./types";

export const isGetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult =
  objectOf<GetDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult>({
    start_time: number,
    end_time: number,
  });

export const isPutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult =
  objectOf<PutDecisioningStudioAgentsAppGroupIdDsaIdTimingQuietHoursResult>({
    start_time: number,
    end_time: number,
  });
